<template>
  <sc-taginput
    :allow-new="false"
    autocomplete
    :data="localwarehouses"
    field="title"
    @input="text => updateTagList(text, warehouseModel)"
    @typing="text => getFilteredTags(text, warehouseModel)"
    :open-on-focus="true"
    v-model="warehouseModel"
    placeholder="Selecione"
    :loading="loading">
      <template slot-scope="props">
        {{ props.option.code }} • {{ props.option.official_name }}
      </template>
  </sc-taginput>
</template>

<script>
  import { Storage, Lodash } from '@intelipost-js/secure-providers';
  import { ScTaginput } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapActions, mapState } = createNamespacedHelpers('warehousesDropdown');

  export default {
    name: 'sc-warehouse-taginput',
    props: {
      /**
       * @model
       */
      value: {
        type: Array,
        default: () => [],
      },
      listUser: {
        type: Boolean,
        default: false,
      },
      formFields: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        warehouseModel: [],
        localwarehouses: [],
      };
    },
    watch: {
      value(value) {
        this.warehouseModel = value;
      },
      warehouseModel(warehouseModel) {
        this.$emit('input', warehouseModel);
      },
      formFields(value) {
        if (value.warehouseIds.length < 1 && this.value.length < 1) {
          this.localwarehouses = this.filterUserWarehouses(this.warehouses)
            .map(item => Object.assign(item, { title: `${item.code} • ${item.official_name} ` }));
        }
      },
    },
    computed: {
      ...mapState([
        'warehouses',
        'loading',
      ]),
    },
    methods: {
      ...mapActions(['getWarehouses']),
      getFilteredTags(text, status) {
        this.localwarehouses = this
          .filterUserWarehouses(this.warehouses)
          .filter(state => !status.find(item => item.id === state.id))
          .map(item => Object.assign(item, { title: `${item.code} • ${item.official_name} ` }))
          .filter(option => option.title
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0);
      },
      updateTagList(text, status) {
        this.localwarehouses = this.filterUserWarehouses(this.warehouses)
          .filter(state => !status.find(item => item.id === state.id))
          .map(item => Object.assign(item, { title: `${item.code} • ${item.official_name} ` }));
      },
      sortWh(wh) {
        return wh.sort((a, b) => {
          if (a.official_name.toLowerCase() < b.official_name.toLowerCase()) {
            return -1;
          }

          if (a.official_name.toLowerCase() > b.official_name.toLowerCase()) {
            return 1;
          }

          return 0;
        });
      },
      filterUserWarehouses(wh) {
        // Obtem as warehouses IDs do usuário armazenadas no Storage
        const userWarehousesIds = Storage.get('user').warehouse_ids;
        // Vetor pra guardar só objetos warehouses do usuário logado
        const userWarehouses = [];

        // Se for definido para listar só warehouses do usuário
        if (this.listUser) {
          // Percorre os IDs do Storage
          userWarehousesIds.forEach((userWarehousesId) => {
            // Busca por ID na lista de todas warehouses (do cliente)
            const userWarehouse = wh.find(warehouse => userWarehousesId === warehouse.id);
            // Caso encontre guarda no Vetor de objetos warehouses do usuário logado
            if (Object.keys(userWarehouse).length > 0) {
              userWarehouses.push(userWarehouse);
            }
          });
          // Retorna warehouses do usuário
          return this
            .sortWh(userWarehouses.filter(({ code = '', official_name = '' }) => code && official_name));
        }

        // Retorna todas warehouses do cliente
        return this
          .sortWh(wh.filter(({ code = '', official_name = '' }) => code && official_name));
      },
    },
    created() {
      this.getWarehouses().then(({ data = {} }) => {
        const { warehouses = [] } = data;
        this.localwarehouses = this.filterUserWarehouses(Lodash.cloneDeep(warehouses))
          .map(item => Object.assign(item, { title: `${item.code} • ${item.official_name} ` }));
        if (this.value.length > 0) {
          this.warehouseModel = Lodash.cloneDeep(this.value);
        }
        return data;
      });
    },
    components: {
      ScTaginput,
    },
  };
</script>

<style lang="scss">
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0ms;
  }
  .fade-enter,
  .fade-leave-to {
      opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-psl/features/list/components/ScWarehouseTaginput.vue